import { resetForgotPassword } from '@/api';
import Button from '@/components/shared/Button';
import Input from '@/components/shared/Input';
import { Form, Formik, getIn } from 'formik';
import logo from '@/img/propsavvy-logo-with-text.svg';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import getAxiosErrors from '@/utils/getAxiosErrors';
import * as Yup from 'yup';
import './ForgotChangePassword.scss';

const baseClass = 'ForgotChangePassword';

interface IValues {
  password: '';
  confirmPassword: '';
}

const initialValues: IValues = {
  password: '',
  confirmPassword: '',
};

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required('Password is required')
    .min(5, 'Password must be at least 5 characters')
    .max(128, 'Password must be at most 128 characters')
    // Проверка на наличие заглавной буквы
    .matches(
      /(?=.*[A-Z])/,
      'Password must contain at least one uppercase letter',
    )
    // Проверка на наличие цифры или специального символа
    .matches(
      /(?=.*\d)|(?=.*\W+)/,
      'Password must contain at least one number or special character',
    ),
  confirmPassword: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('password')], 'Passwords must match'),
});

function ForgotChangePasswordPage() {
  const { token } = useParams(); // Получение токена из URL
  const navigate = useNavigate();
  return (
    <div className={baseClass}>
      <div className={`${baseClass}-view`}>
        <div className={`${baseClass}-view-logo`}>
          <img src={logo} alt="logo" />
          <p className={`${baseClass}-view-logo-desc`}>
            Please enter your new password.
          </p>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={({ password }, { setSubmitting, setErrors, setStatus }) => {
            if (token) {
              resetForgotPassword({ password, token })
                .then((res) => {
                  if (res.status === 200) {
                    setStatus({ success: 'Password reset successfully' });
                    navigate('/login');
                  }
                  setStatus({ error: 'Password reset error' });
                })
                .catch((err) => {
                  setErrors(getAxiosErrors(err));
                  setStatus({ error: 'Password reset error' });
                })
                .finally(() => {
                  setSubmitting(false);
                });
            }
          }}
        >
          {({
            values,
            status,
            handleChange,
            handleBlur,
            errors,
            touched,
            isSubmitting,
          }) => (
            <Form className={`${baseClass}-view-form`}>
              <div className={`${baseClass}-view-form-group`}>
                <Input
                  floatLabel
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                  name="password"
                  type="password"
                  label="Password"
                  errors={
                    getIn(errors, 'password') && getIn(touched, 'password')
                      ? getIn(errors, 'password')
                      : ''
                  }
                />
                <Input
                  floatLabel
                  className={`${baseClass}-view-form-group-password`}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.confirmPassword}
                  name="confirmPassword"
                  type="password"
                  label="Confirm password"
                  errors={
                    getIn(errors, 'confirmPassword') &&
                    getIn(touched, 'confirmPassword')
                      ? getIn(errors, 'confirmPassword')
                      : ''
                  }
                />
                {status && status.error && (
                  <div className={`${baseClass}--error`}>{status.error}</div>
                )}
              </div>
              <div className={`${baseClass}-view-form-group-submit`}>
                <Button
                  type={'submit'}
                  className={`${baseClass}-view-form-group-submit-btn`}
                  isDisabled={isSubmitting}
                  isLoading={isSubmitting}
                >
                  Save
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default ForgotChangePasswordPage;
